var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowdown = function SvgArrowdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.968 3.982 6.006.484l5.016 3.498v2.156L6.006 2.816.968 6.138V3.982Z",
    fill: "#fff"
  })));
};

export { SvgArrowdown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDEyIDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjk2Nzk3MiAzLjk4MjE4TDYuMDA1OTcgMC40ODQxODRMMTEuMDIyIDMuOTgyMThMMTEuMDIyIDYuMTM4MThMNi4wMDU5NyAyLjgxNjE4TDAuOTY3OTcyIDYuMTM4MThMMC45Njc5NzIgMy45ODIxOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";